import { useState } from "react";

function ShowModal(props) {
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [links, setLinks] = useState('');
  const [size, setSize] = useState(Number);
  const [picture, setPicture] = useState('');

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handelTitle = (event) => {
    setTitle(event.target.value);
  };

  const handelDescription = (event) => {
    setDescription(event.target.value);
  };

  const handelLinks = (event) => {
    setLinks(event.target.value);
  };

  const handelSize = (event) => {
    setSize(event.target.value);
  };

  const onImageChangeString = (event) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = function (e) {
        setPicture(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const onSubmit = () => {
    let newInformation = {
      Title: title,
      Description: description,
      Href: links,
      Size: size,
      Picture: picture,
    };
    props.onSubmit && props.onSubmit(newInformation);
    props.onUpdate && props.onUpdate(newInformation);
  };

  const handelonSubmit = () => {
    onSubmit();
    handleClose();
  };

  return (
    <>
      <button
        className="bg-blue-500 text-white active:bg-blue-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
        type="button"
        onClick={handleShow}
      >
        {props.button}
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-3xl font-semibold text-black">{props.title}</h3>
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto">
                  <label hidden={props.hiddenPicture}>
                    <h5 className="mb-2 text-sm font-medium text-gray-900">
                      عکس
                    </h5>
                    <input
                      type="file"
                      className="mb-2"
                      onChange={onImageChangeString}
                    />
                  </label>
                  <label hidden={props.hiddenTitle}>
                    <h5 className="mb-2 text-sm font-medium text-gray-900">
                      تیتر
                    </h5>
                    <input
                      type="text"
                      className="bg-gray-50 border mb-2 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      value={title}
                      onChange={handelTitle}
                      placeholder="متن خود را وارد کنید"
                    />
                  </label>
                  <label hidden={props.hiddenDescription}>
                    <h5 className="mb-2 text-sm font-medium text-gray-900">
                      توضیحات
                    </h5>
                    <input
                      type="text"
                      className="bg-gray-50 border mb-2 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      value={description}
                      onChange={handelDescription}
                      placeholder="متن خود را وارد کنید"
                    />
                  </label>
                  <label hidden={props.hiddenHref}>
                    <h5 className="mb-2 text-sm font-medium text-gray-900">
                      لینک ها
                    </h5>
                    <input
                      type="text"
                      className="bg-gray-50 border mb-2 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      value={links}
                      onChange={handelLinks}
                      placeholder="لینک های خود را وارد کنید"
                    />
                  </label>
                  <label hidden={props.hiddenSize}>
                    <h5 className="mb-2 text-sm font-medium text-gray-900">
                      اندازه ها
                    </h5>
                    <input
                      type="number"
                      className="bg-gray-50 border mb-2 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      value={size}
                      onChange={handelSize}
                      placeholder="اندازه مهارت خود را وارد کنید"
                    />
                  </label>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={handleClose}
                  >
                    بستن
                  </button>
                  <button
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={handelonSubmit}
                  >
                    ذخیره کردن
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}

export default ShowModal;
